import { React } from "react";
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";

import logo from "../../../assets/Aspetto_Login.png";
const styles = StyleSheet.create({
  label: {
    marginTop: 24,
    flexDirection: "column",
  },
  titleContainer: {
    marginTop: 20,
  },
  reportTitle: {
    color: "black",
    fontSize: 10,
    textAlign: "center",
    textTransform: "uppercase",
    fontWeight: "extrabold",
  },
  Quote_Title: {
    color: "black",
    fontSize: 14,
    textAlign: "center",
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  logo: {
    width: 150,
    height: 50,
    marginLeft: "auto",
    marginRight: "auto",
    alignContent: "end",
  },
  Image_con: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  },
  Address: {
    width: 190,
    height: 40,
  },
  address: {
    fontSize: 9,
    fontWeight: "bold",
    marginTop: 10,
    textAlign: "left",
  },
  Address_con: {
    width: "60%",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  add_line: {
    fontSize: 9,
  },
  logo_con: {
    width: "40%",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "flex-end",
  },
});
const InvoiceTitle = ({ invoice }) => {
  return (
    <>
      <View style={styles.Image_con}>
        <View style={styles.Address_con}>
          {/* <Text style={styles.address}>Aspetto, Inc.</Text> */}
          <Text style={styles.add_line}>{invoice?.from_address}</Text>
          {/* <Text style={styles.add_line}>150 Riverside pkwy. Suite 203</Text>
          <Text style={styles.add_line}>Fredericksburg, VA 22406 USA</Text>
          <Text style={styles.add_line}>+1 540-547-8487</Text>
          <Text style={styles.add_line}>info@aspettoinc.com</Text> */}
        </View>
        <View style={styles.logo_con}>
          <Image style={styles.logo} src={logo} />
        </View>
      </View>
    </>
  );
};

export default InvoiceTitle;
